// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Scene_1_wrapper__1gpEo"};